<template>
    <div class="d-inline-block align-top mb-2">
        <multiselect track-by="key"
                     :options="options"
                     :searchable="true"
                     label="name"
                     :multiple="multiple"
                     :allow-empty="empty"
                     :close-on-select="false"
                     :limit="limit" :limitText="limitText"
                     :show-labels="false"
                     :placeholder="trans[locale].selectionLang.search"
                     :customLabel="customLabel"
                     :clear-on-select="false"
                     @select="changeAction"
                     v-model="selected">
            <template slot="placeholder" slot-scope="props">
                <span>{{ placeholder }}</span>
            </template>

            <!-- This this how items html looks like -->
            <template slot="option" slot-scope="props">
                <div>{{ props.option.name }}</div>
            </template>

            <!-- shows when no options in selection -->
            <template slot="noResult" slot-scope="props">
                <span>No result</span>
            </template>

        </multiselect>
    </div>
</template>

<script>

    export default {

        data() {
            return {
                selected: [],
                options: this.init_options,
                value: '',
                locale: window.locale,
                placeholder: this.init_placeholder,
            }
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            init_options: {
                type: Array,
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            init_selected: {
                type: Array,
                default: () => [],
            },
            init_placeholder: {
                type: String,
                default: () => this.trans[this.locale].selectionLang.placeholder,
            },
            select_listen: {
                type: Function,
                default: () => { return false }
            }
        },
        beforeDestroy() {

        },
        mounted() {
            let self = this;
        },
        methods: {
            customLabel({key, name}) {
                return `${name}`
            },
            limitText(count) {
                return `${this.trans[this.locale].selectionLang.selected} (${count})`;
            },
            changeAction(selectedOption) {
                if (_.isFunction(this.select_listen))
                {
                    return this.select_listen(this.name, selectedOption);
                }
            }
        },
        computed: {
            limit() {
                return this.multiple ? 0 : 1;
            },
            empty() {
                return this.multiple ? true : false;
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Select/Choice.vue